// extracted by mini-css-extract-plugin
module.exports = {"dark":"Section_dark__2Qlkl","light":"Section_light__2YYdE"};